module.exports = __webpack_public_path__ + "img/oa.03c445f1.png";